export default __webpack_public_path__ + "static/media/avatar.3f878b39.jpg";